import axios from 'axios';

/**
 * Resolves the store database name for a given store ID.
 *
 * @param {number} storeId - The ID of the store.
 * @returns {Promise<string|null>} A promise that resolves to the store database name, or null if not found.
 */
export async function resolveStoreDatabase(storeId) {
  if (!storeId) {
    console.warn('resolveStoreDatabase: storeId is missing.');
    return null;
  }

  try {
    // Get the store details to find the database name
    const storeUrl = `https://lytningtomcat.chrilantech.com/SubscriptionManager/api/customer/getStoreByID/${storeId}`;
    const storeResponse = await axios.get(storeUrl);
    
    // The property name is "Database" with a capital "D"
    const storeDatabase = storeResponse.data?.Database;

    if (!storeDatabase) {
        console.warn(`Could not resolve store database name for store_id: ${storeId}`);
        return null;
    }
    
    return storeDatabase;

  } catch (error) {
    console.error(`Failed to resolve store database for store ID ${storeId}:`, error);
    return null;
  }
}
